/* jshint esversion: 6 */
/* jshint ignore:start */
import axios from 'axios';
import { useContext, useEffect, useState } from 'react';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { Link, useNavigate } from 'react-router-dom';
import { MyContext } from '../../Context/MyProvider';
import { useTranslation } from 'react-i18next';
import Loading from '../Loading';
import secureLocalStorage from "react-secure-storage";
import { applyImageFallback, buildImageUrl } from '../../utils/image';
export const ImgLoad = ({ url, style }) => {
    const [imgLoaded, setImgLoaded] = useState(false);
    return (
        <img
            src={url}
            alt="Model"
            loading="lazy"
            onLoad={() => setImgLoaded(true)}
            onError={(e) => {
                applyImageFallback(e, process.env.REACT_APP_IMG_BASE_URL || process.env.REACT_APP_API_BASE_URL || "https://portal.rapidmedik.com", "department");
                setImgLoaded(true);
            }}
            className={`${style} ${imgLoaded ? "opacity-100" : "opacity-0"}`}
        />
    )
}

const OurServices = () => {

    const { t } = useTranslation();

    const { ApiBaseUrl, ImgBaseUrl } = useContext(MyContext);

    const [labData, setLabData] = useState([]);
    const [loading, setLoading] = useState(true);

    const navigate = useNavigate();

    const NavigateHandle = (title, id) => {
        sessionStorage.setItem("Docdetails", JSON.stringify({ id: id, title: title, path: "/services", pagename: "Our Services" }));
        navigate("/doctor-details");
    };

    useEffect(() => {
        navigator.geolocation.getCurrentPosition(position => {
            const lat = String(position.coords.latitude);
            const long = String(position.coords.longitude);
            fetchHomeData(lat, long);
        });
    }, []);

    const fetchHomeData = (lat, long) => {
        const Userid = secureLocalStorage.getItem("Userid") || "0";
        if (Userid) {
            axios.post(`${ApiBaseUrl}/customer/home`, { id: Userid, lat: lat, lon: long })
                .then((res) => {
                    const { department_list, ResponseCode } = res.data;
                    if (ResponseCode === 200) {
                        setLabData(department_list);
                    }
                    setLoading(false);
                })
                .catch((error) => {
                    console.error("Home Api", error);
                });
        }
    };

    useEffect(() => {
        document.body.style.overflow = "auto";
    }, [loading]);

    return (
        <div className='width-container content-wrapper'>
            {false ? <Loading CustomeStyle="fixed left-0 top-0 h-[100vh] w-full flex items-center justify-center bg-white" />
                : <div className="mt-[25px] ourservices">
                    <div className="flex items-center justify-between">
                        <Link to="/" className="flex items-center gap-[5px] border-[2px] border-gray-200 rounded-[50px] px-[10px] group py-[4px] hover:bg-black">
                            <IoIosArrowBack className=' group-hover:text-white' />
                            <h1 className='font-[500] group-hover:text-white'> {t("Go Home")}</h1>
                        </Link>
                        <div className="flex items-center gap-[10px] max-_430_:hidden">
                            <Link to="/" className='font-[500] text-gray-700'>{t("Home")}</Link>
                            <IoIosArrowForward />
                            <h1 className='font-[500] text-gray-400'>{t("Our Services")}</h1>
                        </div>
                        <div className="border-[2px] border-gray-200 rounded-[50px] px-[20px] py-[2px] hidden max-_430_:block">
                            <Link to="/" className='font-[500] text-gray-600'>Back</Link>
                        </div>
                    </div>
                    <div className="flex items-center flex-wrap gap-[20px] mt-[20px]">
                        {labData.map((item, index) => {
                            return <div onClick={() => NavigateHandle(item.name, item.id)} key={index} className='card-box'>
                                <ImgLoad url={buildImageUrl(ImgBaseUrl, item.image, "department")} style="w-[100%] h-[100px] object-contain mx-auto rounded-[10px]" />
                                {/* <img className='w-[100%] h-[100px] object-contain mx-auto rounded-[10px]' src={ImgBaseUrl + item.image} alt="" /> */}
                                <h1 className='font-[500] mt-[15px] text-center whitespace-nowrap overflow-hidden overflow-ellipsis'>{item.name}</h1>
                            </div>
                        })}
                    </div>
                </div>}
        </div>
    )
}

export default OurServices
/* jshint ignore:end */